export const hiddenRoutes = [
    'vt-dashboard',
    'prep-rsp',
    'prep-rsp-pay',
    'prep-auto-tag',
    'profile'
];